<template>
	<section class="newsletter-section align-center">
		<div class="row">
			<div class="columns column12">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
				<form class="newsletter">
					<input type="text" :placeholder="$t('formEmail')" />
					<input type="submit" class="button" :value="button" />
				</form>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: 'Subscribe' },
});
</script>

<style lang="scss" scoped>
.newsletter-section {
	padding: 75px 0;
	background: $secondary-background-color;
	color: $body-color;

	form {
		margin-top: 30px;

		input {
			background: $primary-background-color;
			font: inherit;
			padding: 15px;
			margin: 10px 5px;
			height: 52px;
			border: none;
			width: 100%;
			max-width: 300px;
			vertical-align: top;

			&::placeholder {
				color: #888;
			}

			&.button {
				line-height: 22px;
				background: $cta-color;
				color: #fff;
				max-width: 200px;

				&:hover {
					background: $cta-color-hover;
					color: #fff;
				}
			}
		}
	}
}
</style>
